import { atom } from "recoil";

interface MetaState {
    title: string;
}

export const metaAtom = atom<MetaState>({
    key: "metaAtom",
    default: {
        title: "Paldock",
    },
});
